import useSWR from 'swr'

import { isSuccess } from '@/httpRequest'
import { getSessionListUsers } from '@/httpRequest/modules/mesperyIm/sessionListUsers'

const useSessionListUsers = () => {
  const { data: sessionListUsers } = useSWR(
    '/imApi/session/listUsers',
    async () => {
      const resp = await getSessionListUsers({})
      if (isSuccess(resp)) {
        return resp.data.list
      }
      return []
    }
  )

  return {
    sessionListUsers
  }
}

export default useSessionListUsers
